<template>
  <div class="rbox__item">
    <div class="item-header">
      <span class="item-name">{{ item.DIS_ITEM_NM }}</span>
      <button class="btn-delete btn-anim" @mouseup="basketDel">삭제</button>
    </div>
    <div class="item-body" v-if="item.OPTIONITEM.length > 0">
      <ul class="item-list">
        <li v-for="option in item.OPTIONITEM" :key="option">
          <span>{{ option.ITEM_NM }}</span>
          <span>+{{ $displayUprc($detailUprc(option)) }}</span>
        </li>
      </ul>
    </div>
    <div class="item-footer">
      <div class="btn-wrap-bdr">
        <button
          class="btn-add btn-anim"
          @mouseup="
            if (SALES_QTY > 1) SALES_QTY--;
            changeQty(SALES_QTY);
          "
        >
          빼기
        </button>
        <span>{{ SALES_QTY }}</span>
        <button
          class="btn-out btn-anim"
          @mouseup="
            if (SALES_QTY > 0) SALES_QTY++;
            changeQty(SALES_QTY);
          "
        >
          더하기
        </button>
      </div>
      <span class="item-price">{{ $displayUprc(SALES_QTY * ($detailUprc(item) + totOptUprc)) }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'basket',
  props: {
    item: Object,
    num: Number,
  },
  methods: {
    //장바구니에서 상품 삭제
    basketDel() {
      this.$logInfo(`Basket Delete DIS_ITEM_CD : ${this.item.DIS_ITEM_CD}`);
      this.$emit('delBasket', this.num);
    },
    //장바구니 상품 수량 변경
    changeQty(qty) {
      this.$logInfo(`Basket Qty Change DIS_ITEM_CD : ${this.item.DIS_ITEM_CD}, Qty : ${qty}`);
      this.$emit('changeQty', this.num, qty);
    },
  },
  data() {
    return {
      SALES_QTY: this.item.SALES_QTY,
      darkModeYn: this.$store.getters.getDarkModeYn,
    };
  },
  updated() {},
  mounted() {
    this.$showButtonAnimation();
  },
  components: {},
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
    totOptUprc() {
      let sum = 0;
      this.item.OPTIONITEM.forEach((opt) => {
        sum += this.$detailUprc(opt);
      });
      return sum;
    },
  },
  watch: {
    darkMode(value) {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/main.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/main-dark.css" scoped></style>
<style scoped></style>
